import { useQueryClient } from "@tanstack/react-query";
import { Link, Outlet, useLocation, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { post } from "@/lib/api";
import { useSession } from "@/lib/session";
import { useCart } from "@/lib/shop";

import { Icon } from "./ui";

export function AppLayout() {
  const session = useSession();
  const user = session.data?.user;
  const cart = useCart();
  const [menu, setMenu] = useState(false);
  const [search, setSearch] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const client = useQueryClient();
  useEffect(() => { setMenu(false); }, [location.pathname]);
  async function logout() {
    await post("/auth/logout/");
    client.clear();
    await navigate({ to: "/" });
  }
  return <>
    <a className="skip-link" href="#main">Aller au contenu</a>
    <div className="announcement">De belles pièces. De nouvelles histoires. <span>À Dakar, avec amour.</span></div>
    <header className="site-header">
      <div className="header-main shell">
        <Link to="/" className="wordmark" aria-label="Revi, accueil"><img src="/icons/Revi-logo.png" alt="Revi" width="300" height="120" /></Link>
        <form className="header-search" role="search" onSubmit={(event) => {
          event.preventDefault(); void navigate({ to: "/catalogue", search: { q: search || undefined } });
        }}>
          <Icon name="search" size={18} />
          <input aria-label="Rechercher une pièce" placeholder="À la recherche d'une belle pièce ?" value={search}
            onChange={(event) => setSearch(event.target.value)} />
          <kbd>Entrée ↵</kbd>
        </form>
        <div className="header-actions">
          <Link to="/panier" className="icon-button cart-link" aria-label={"Panier, " + (cart.data?.count ?? 0) + " article(s)"}><Icon name="cart" />{Boolean(cart.data?.count) && <span className="cart-count">{cart.data!.count > 99 ? "99+" : cart.data!.count}</span>}</Link>
          <Link to="/favoris" className="icon-button desktop-action" aria-label="Mes favoris"><Icon name="heart" /></Link>
          <Link to={user ? "/mon-compte" : "/connexion"} className="account-link" aria-label={user ? "Mon compte" : "Se connecter"}>
            <Icon name="user" /><span>{user ? user.first_name || "Mon compte" : "Se connecter"}</span>
          </Link>
          <Link to="/deposer" className="button button-dark sell-button"><Icon name="plus" size={17} /> Vendre une pièce</Link>
          <button className="icon-button mobile-menu" aria-label={menu ? "Fermer le menu" : "Ouvrir le menu"}
            aria-expanded={menu} onClick={() => setMenu(!menu)}><Icon name={menu ? "close" : "menu"} /></button>
        </div>
      </div>
      <nav className={"main-nav shell " + (menu ? "is-open" : "")} aria-label="Navigation principale">
        <div>
          <Link to="/boutique">Boutique Revi</Link>
          <Link to="/catalogue" activeOptions={{ exact: true }}>Toutes les pièces</Link>
          <Link to="/catalogue" search={{ kind: "furniture" }}>Mobilier & décoration</Link>
          <Link to="/catalogue" search={{ kind: "fashion" }}>Mode & luxe</Link>
          <Link to="/comment-ca-marche">L'esprit Revi</Link>
        </div>
        <div>
          <Link to="/tarifs">Nos tarifs</Link>
          <Link to="/services">Nos services <span className="nav-dot" /></Link>
          {user?.is_staff && <Link to="/moderation">Modération</Link>}
          {user?.is_staff && <Link to="/gestion-commandes">Commandes</Link>}
          {user && <button className="text-button mobile-logout" onClick={() => void logout()}>Déconnexion</button>}
        </div>
      </nav>
    </header>
    <main id="main" tabIndex={-1}><Outlet /></main>
    <section className="closing-note shell"><span>Les belles choses méritent</span><em>une seconde histoire.</em>
      <Link to="/deposer" className="button button-outline">Confier ma pièce à Revi <Icon name="arrow" size={17} /></Link>
    </section>
    <footer className="site-footer">
      <div className="footer-grid shell">
        <div><Link to="/" className="wordmark" aria-label="Revi, accueil"><img src="/icons/Revi-logo.png" alt="Revi" width="300" height="120" loading="lazy" /></Link><p>La seconde main, autrement.<br />Des pièces choisies, des histoires à partager.<br />Dakar, Sénégal.</p></div>
        <div><h3>Explorer</h3><Link to="/boutique">Boutique Revi</Link><Link to="/mes-commandes">Mes commandes</Link><Link to="/catalogue" search={{ kind: "furniture" }}>Mobilier & décoration</Link>
          <Link to="/catalogue" search={{ kind: "fashion" }}>Mode & luxe</Link><Link to="/favoris">Mes coups de cœur</Link></div>
        <div><h3>Vendre avec Revi</h3><Link to="/comment-ca-marche">Comment ça marche</Link><Link to="/tarifs">Tarifs de publication</Link>
          <Link to="/services">Photo & Instagram</Link><Link to="/deposer">Déposer une annonce</Link></div>
        <div><h3>À votre écoute</h3><Link to="/contact">Nous contacter</Link><Link to="/faq">Questions fréquentes</Link>
          <Link to="/conditions">Conditions de dépôt</Link><Link to="/confidentialite">Confidentialité</Link></div>
      </div>
      <div className="footer-bottom shell"><span>© {new Date().getFullYear()} Revi. Toutes les belles histoires commencent ici.</span>
        <span>Conçu à Dakar · 3X Agency</span></div>
    </footer>
  </>;
}
